import 'scss/services/offline_iat.scss'
import 'babel-polyfill'
import {
  serviceQA,
  serviceTopbar
} from 'js/libs/utils-services'
import {
  init as initServiceOpen,
  showserviceOpenModal
} from 'js/libs/utils-services-open'
import { config } from 'config'
import 'js/libs/gt'
import { layer } from 'js/libs/utils-layer'
import { goServiceBuy } from 'js/libs/utils-services-buy'

$(function () {
  $('.answer-table .buy-btn').click(function () {
    let packageId = $(this).attr('package-id')
    let params = {
      wareId: '2006',
      packageId: packageId,
      serviceName: '离线语音听写',
      businessId: 'esriat'
    }
    goServiceBuy(params)
  })
  serviceQA()
  serviceTopbar()
  initServiceOpen()
  $('.to-service-open').click(function () {
    showserviceOpenModal({
      urlParams: { 'currPage': '1' }
    }, {
      detailUrl: `${config.CONSOLE}/app/myapp`,
      appIdKey: 'keyword',
      needBase64: false
    })
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/services/offline_iat.js